import { httpClient2 } from 'src/infrastructure/admi-client/http-client';
import { Owner } from './crm.dto';

export const admiOwnerService = {
    async searchOwners(filter: string): Promise<Owner[]> {
        const response = await httpClient2.get<Owner[]>('/v2/crm/owners/search', { params: { filter } });
        return response.data;
    },

    /**
     * Single-owner lookup. Used by the REA list view to hydrate the AM
     * Autocomplete's display name when the page is deep-linked with an id.
     * Resolves to `null` if HubSpot answers 404 so the caller can fall back
     * to a placeholder instead of throwing.
     */
    async getOwnerById(id: string): Promise<Owner | null> {
        try {
            const response = await httpClient2.get<Owner>(`/v2/crm/owners/${encodeURIComponent(id)}`);
            return response.data;
        } catch (error) {
            if ((error as { response?: { status?: number } }).response?.status === 404) return null;
            throw error;
        }
    },
};
